import { useEffect } from "react";
import WOW from "wowjs";

function PageScripts() {
  useEffect(() => {
    // Initialize WOW.js
     if (typeof SVGElement !== 'undefined') {
      Object.defineProperty(SVGElement.prototype, 'className', {
        get() { return this.getAttribute('class') || ''; },
        set(value) { this.setAttribute('class', value); },
        configurable: true,
      });
    }

    // Initialize WOW.js
    new WOW.WOW({ live: false }).init();
    

    const cleanupFns = [];
    let tabTimer;
    let isotopeInstance = null;
    let lenisInstance = null;
    let rafId = null;

    /* ---------------- Active Menu ---------------- */
    const updateActiveMenu = () => {
      try {
        const cur_pos = window.scrollY || document.documentElement.scrollTop;
        const sections = Array.from(document.querySelectorAll("section"));

        document.querySelectorAll("#mainmenu a").forEach(a => a.classList.remove("active"));
        sections.forEach(s => s.classList.remove("active"));

        for (const sec of sections) {
          const top = sec.offsetTop - 120;
          const bottom = top + sec.offsetHeight;

          if (cur_pos >= top && cur_pos <= bottom) {
            sec.classList.add("active");
            const link = document.querySelector(`#mainmenu a[href="#${sec.id}"]`);
            if (link) link.classList.add("active");
            break;
          }
        }
      } catch (err) {
        console.warn("Menu update error:", err);
      }
    };
    setTimeout(updateActiveMenu, 200);

    /* ---------------- Scroll Listener ---------------- */
    const onScroll = () => updateActiveMenu();
    window.addEventListener("scroll", onScroll, { passive: true });
    cleanupFns.push(() => window.removeEventListener("scroll", onScroll));



    /* ---------------- Lenis ---------------- */
    const initLenis = () => {
      const timer = setInterval(() => {
        if (window.Lenis) {
          clearInterval(timer);
          if (lenisInstance?.destroy) lenisInstance.destroy();
          if (rafId) cancelAnimationFrame(rafId);

          lenisInstance = new window.Lenis({
            smooth: true,
            duration: 0.6,
            easing: t => 1 - Math.pow(1 - t, 3),
          });

          const raf = time => {
            lenisInstance.raf(time);
            rafId = requestAnimationFrame(raf);
          };
          rafId = requestAnimationFrame(raf);
        }
      }, 100);
      setTimeout(() => clearInterval(timer), 5000);
    };
    initLenis();

    /* ---------------- Tabs Auto Change ---------------- */
    const tabs = document.querySelectorAll(".tabBtn");
    const slides = document.querySelectorAll(".slide");
    let current = 0;

    const showSlide = index => {
      tabs.forEach(t => t.setAttribute("aria-selected", "false"));
      slides.forEach(s => s.classList.remove("active"));

      slides[index]?.classList.add("active");
      tabs[index]?.setAttribute("aria-selected", "true");
    };

    const startLoop = () => {
      clearInterval(tabTimer);
      tabTimer = setInterval(() => {
        current = (current + 1) % slides.length;
        showSlide(current);
      }, 3000);
    };

    if (tabs.length && slides.length) {
      tabs.forEach((tab, i) => {
        const handler = () => {
          current = i;
          showSlide(i);
          startLoop();
        };
        tab.addEventListener("click", handler);
        cleanupFns.push(() => tab.removeEventListener("click", handler));
      });

      showSlide(0);
      startLoop();
    }

    /* ---------------- Search Panel & Mobile Nav Panel ---------------- */
    const searchIcon = document.querySelector(".searchimg");
    const closeIcon = document.querySelector(".closeimg");
    const panel = document.querySelector(".expendsearch");
    const expendcontDIV = document.querySelector(".expendcontDIV");
    const navbarIcon = document.querySelector(".GRIDbutton-wrapper");
    const input = panel?.querySelector(".searchbox");

    // Search panel functions
    const openPanel = () => {
      // Close mobile nav if open
      if (expendcontDIV?.classList.contains("open")) {
        closeexpendcontDIV();
      }
      panel?.classList.add("open");
      searchIcon?.classList.add("d-none");
      closeIcon?.classList.remove("d-none");
      setTimeout(() => input?.focus(), 150);
    };

    const closePanel = () => {
      panel?.classList.remove("open");
      closeIcon?.classList.add("d-none");
      searchIcon?.classList.remove("d-none");
      input?.blur();
      
      // Dispatch custom event to clear React state
      window.dispatchEvent(new Event('clearSearchInput'));
    };

    // Mobile nav panel functions
    const openexpendcontDIV = () => {
      // Close search panel if open
      if (panel?.classList.contains("open")) {
        closePanel();
      }
      expendcontDIV?.classList.add("open");
    };

    const closeexpendcontDIV = () => {
      expendcontDIV?.classList.remove("open");
    };

    const toggleexpendcontDIV = (e) => {
      e.stopPropagation();
      if (expendcontDIV?.classList.contains("open")) {
        closeexpendcontDIV();
      } else {
        openexpendcontDIV();
      }
    };

    // Event handlers
    const onSearchClick = e => { 
      e.stopPropagation(); 
      openPanel(); 
    };

    const onCloseClick = e => { 
      e.stopPropagation(); 
      closePanel();
      // Close mobile nav if open
      if (expendcontDIV?.classList.contains("open")) {
        closeexpendcontDIV();
      }
    };

    const onPanelClick = e => {
      // Don't stop propagation if clicking the input close button
      if (e.target.classList.contains('inputclose')) {
        return;
      }
      e.stopPropagation();
    };

    const onexpendcontDIVClick = e => {
      // Allow clicks on menu items to pass through
      if (e.target.classList.contains('conmenu-item')) {
        closeexpendcontDIV();
        return;
      }
      e.stopPropagation();
    };

    const onDocClick = () => { 
      if (panel?.classList.contains("open")) closePanel(); 
      if (expendcontDIV?.classList.contains("open")) closeexpendcontDIV();
    };

    const onKeyDown = e => { 
      if (e.key === "Escape") {
        if (panel?.classList.contains("open")) closePanel();
        if (expendcontDIV?.classList.contains("open")) closeexpendcontDIV();
      }
    };

    // Listen for clicks on mobile menu items
    const mobileMenuItems = document.querySelectorAll('.expendcontDIV .conmenu-item');
    mobileMenuItems.forEach(item => {
      const handler = () => {
        closeexpendcontDIV();
      };
      item.addEventListener('click', handler);
      cleanupFns.push(() => item.removeEventListener('click', handler));
    });

    // Attach event listeners
    searchIcon?.addEventListener("click", onSearchClick);
    closeIcon?.addEventListener("click", onCloseClick);
    panel?.addEventListener("click", onPanelClick);
    navbarIcon?.addEventListener("click", toggleexpendcontDIV);
    expendcontDIV?.addEventListener("click", onexpendcontDIVClick);
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKeyDown);

    cleanupFns.push(() => {
      searchIcon?.removeEventListener("click", onSearchClick);
      closeIcon?.removeEventListener("click", onCloseClick);
      panel?.removeEventListener("click", onPanelClick);
      navbarIcon?.removeEventListener("click", toggleexpendcontDIV);
      expendcontDIV?.removeEventListener("click", onexpendcontDIVClick);
      document.removeEventListener("click", onDocClick);
      document.removeEventListener("keydown", onKeyDown);
    });

    /* ---------------- Cleanup ---------------- */
    return () => {
      cleanupFns.forEach(fn => fn());
      if (isotopeInstance) isotopeInstance.destroy();
      if (lenisInstance?.destroy) lenisInstance.destroy();
      if (rafId) cancelAnimationFrame(rafId);
      if (tabTimer) clearInterval(tabTimer);
    };
  }, []);

  return null;
}

export default PageScripts;